import { useLocation } from "react-router-dom";

export function useShopFlow() {
    const location = useLocation();
    const path = location.pathname.toLowerCase();

    return (
        path.includes("/shop") ||
        path.includes("/cart") ||
        path.includes("/checkout") ||
        path.includes("/orders") ||
        path.includes("/profile") ||
        path.includes("/favorites")
    );
}
